import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H3 } from 'foundations-components/transitional/components/H3';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Pictogram } from 'foundations-components/transitional/components/Pictogram';
import { Section } from 'foundations-components/transitional/components/Section';
import { View } from 'foundations-components/components/View';
// @ts-expect-error Could not find a declaration file for module
import TrackCompleteInterstitial from '../../components/ContentInterstitials/PostTrackInterstitial/TrackCompleteInterstitial';
// @ts-expect-error Could not find a declaration file for module
import TrackIncompleteInterstitial from '../../components/ContentInterstitials/PostTrackInterstitial/TrackIncompleteInterstitial';
import UsageTracker from '../../utils/UsageTracker';
import { SCREENS, SUB_SCREENS } from '../../constants/Tracking.migrated';
import TrackIntroductionInformation from '../../components/TrackPage/TrackIntroductionInformation';
import { HasParentPlaylist, NextPlaylistContent } from '../../features/playlistContent/index.migrated';
import FinishedContainer from '../../components/FinishedContainer.migrated';
import TrackCertificationCompletionScreen from '../../components/TrackPage/TrackCertificationCompletionScreen';
import { useUserInfo } from '../../features/accounts';
import { useTrackAwardPolling } from '../../features/userProgress';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const TrackFinishedPageContainer = ({
  track,
  trackProgress
}) => {
  const {
    userInfo
  } = useUserInfo();
  const trackIsComplete = (trackProgress === null || trackProgress === void 0 ? void 0 : trackProgress.status) === 'COMPLETED';
  const isCertNoExamCourse = !!(track.certification && !track.exam);
  const shouldPollForAward = isCertNoExamCourse && trackIsComplete && !(trackProgress !== null && trackProgress !== void 0 && trackProgress.trackAward);
  const polledTrackAward = useTrackAwardPolling({
    shouldPoll: shouldPollForAward,
    trackId: track.id
  });
  const trackAward = isCertNoExamCourse ? polledTrackAward !== null && polledTrackAward !== void 0 ? polledTrackAward : trackProgress === null || trackProgress === void 0 ? void 0 : trackProgress.trackAward : trackProgress === null || trackProgress === void 0 ? void 0 : trackProgress.trackAward;
  const isWaitingForCertAward = isCertNoExamCourse && trackIsComplete && !trackAward;
  useEffect(() => {
    UsageTracker.track('subpageView', {
      screen: SCREENS.TRACK,
      subscreen: SUB_SCREENS.CONCLUSION,
      trackId: track.id,
      trackIsComplete
    });
  }, [track.id, trackIsComplete]);
  if (isWaitingForCertAward) {
    return /*#__PURE__*/_jsx(FinishedContainer, {
      body: /*#__PURE__*/_jsxs(View, {
        children: [/*#__PURE__*/_jsx(H3, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.tracks.interstitials.certificationCompleteHeading",
            options: {
              firstName: userInfo && userInfo.user.firstName
            }
          })
        }), /*#__PURE__*/_jsx(Section, {
          children: /*#__PURE__*/_jsx(LoadingSpinner, {
            label: I18n.text('learningCenter.exams.finished.loadingCertificate'),
            showLabel: true
          })
        })]
      }),
      illustration: /*#__PURE__*/_jsx(Pictogram, {
        name: "CelebrationSuccess"
      })
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    children: [trackIsComplete ? /*#__PURE__*/_jsx(NavMarker, {
      name: "COURSE_CONCLUSION_COMPLETE_VIEW_LOADED",
      children: /*#__PURE__*/_jsx(HasParentPlaylist, {
        fallback: trackAward ? /*#__PURE__*/_jsx(TrackCertificationCompletionScreen, {
          track: track,
          trackAward: trackAward
        }) : /*#__PURE__*/_jsx(TrackCompleteInterstitial, {}),
        children: /*#__PURE__*/_jsx(NextPlaylistContent, {
          render: ({
            url,
            showPlaylistNavigatorCta
          }) => /*#__PURE__*/_jsx(TrackCompleteInterstitial, {
            buttonI18n: showPlaylistNavigatorCta ? 'learningCenter.tracks.interstitials.next' : undefined,
            buttonLink: showPlaylistNavigatorCta ? url : undefined,
            hideButton: !showPlaylistNavigatorCta
          }),
          trackId: track.id
        })
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(NavMarker, {
        name: "COURSE_CONCLUSION_INCOMPLETE_VIEW_LOADED",
        children: /*#__PURE__*/_jsx(HasParentPlaylist, {
          fallback: /*#__PURE__*/_jsx(TrackIncompleteInterstitial, {}),
          children: /*#__PURE__*/_jsx(NextPlaylistContent, {
            render: ({
              url,
              showPlaylistNavigatorCta
            }) => /*#__PURE__*/_jsx(TrackIncompleteInterstitial, {
              buttonI18n: showPlaylistNavigatorCta ? 'learningCenter.tracks.interstitials.next' : undefined,
              buttonLink: showPlaylistNavigatorCta ? url : undefined,
              hideButton: !showPlaylistNavigatorCta
            }),
            trackId: track.id
          })
        })
      }), /*#__PURE__*/_jsx(TrackIntroductionInformation, {
        track: track
      })]
    }), /*#__PURE__*/_jsx(NavMarker, {
      name: "COURSE_CONCLUSION_VIEW_LOADED"
    })]
  });
};
export default TrackFinishedPageContainer;